import { LoanHistory } from "@/pages/laptops/LoanHistory"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/laptops/$laptopId/leengeschiedenis",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { laptopId } = useParams({
    from: "/beheer/laptops/$laptopId/leengeschiedenis",
  })

  return <LoanHistory laptopId={Number(laptopId)} />
}
